import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

// Create the context
const LoggedUserContext = createContext();

// Hook to use the context
export const useUser = () => useContext(LoggedUserContext);

// Provider component
export const LoggedUserProvider = ({ children }) => {
  const [userId, setUserId] = useState("ANONYMOUS");

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      // Retrieve the JWT from cookies
      const token = Cookies.get('token');

      // Get user by token
      fetch(`${process.env.REACT_APP_API_URL}/users/token/${token}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.id_user) {
            setUserId(data.id_user);
          }
        })
    }
  }, [userId]);

  return (
    <LoggedUserContext.Provider value={{ userId, setUserId }}>
      {children}
    </LoggedUserContext.Provider>
  );
}